module.exports = __webpack_public_path__ + "media/images/emblems/Moerschwil_blazono-be95d48397f7307d50780951bb37b780.png";